require( 'modal' );
require( 'draggable' );

;(function ( $, window, document, undefined ){

    var _setUniqueId = function ( id ){
        if ( !id ) {
            return Math.round( new Date().getTime() + (Math.random() * 100) );
        }
        return id;
    };

    var dragableModals = $('.modal.draggable');

    $.each(dragableModals, function ( idx, modal ){
        $( modal ).on( 'dragEnd', function ( e ){
            $( this ).children( '.modal-dialog' ).css( 'transform', 'translate(0,0)' );
        } );
    });

    $.modalizer = function ( options ){

        if ( $.type( options ) == 'string' ) {
            options = {
                body: options
            };//options
        }//if

        // set the default options
        options = $.extend( true, {}, $.modalizer.options, options );

        // return console log for incorrect usage of modalizer.
        var validCategories = [ 'default', 'info', 'success', 'warning', 'danger' ];
        if ( $.inArray( options.category, validCategories ) == -1 ) {
            return console.error( options.category + ' is not a valid category.' );
        } else if ( !options.alert && options.category != 'default' ) {
            return console.error( 'Missing alert option while using ' + options.category + ' as category.' );
        }

        // close any dialog with this id first
        $( '#' + options.id ).modal( 'hide' );

        // create the modal html

        var escapedBody = $.parseHTML( options.body ),
            escapedTitle = $.parseHTML( options.title );

        var $div = $( [
            '<div id="' + options.id + '" tabindex="-1" role="dialog" class="modal dv-modal">',
            '  <div class="modal-dialog ' + options.size + '">',
            '      <div class="modal-content">',
            '        <div class="modal-header">',
            '          <h4 class="modal-title"></h4>',
            '        </div>',
            '        <div id="' + options.bodyID + '" class="modal-body">',
            '        </div>',
            '      </div>',
            '    </div>',
            '  </div>',
        ].join( '\n' ) );

        // add the new modal div to the body and show it!
        $( options.appendToSelector ).append( $div );

        // add the escaped body DOM
        $div.find( '.modal-body' ).html( escapedBody );

        $div.modal( options.modal );


        // add title if set otherwise create an empty title to prevente the (x) from hanging.
        if ( options.title === '' ) {
            $div.find( '.modal-title' ).html( '&nbsp;' );
        } else {
            $div.find( '.modal-title' ).html( escapedTitle );
        }

        // remove header when title is empty and (x) is not visible
        if ( options.title === '' && options.closeButton === false ) {
            $div.find( '.modal-header' ).remove();
        }

        // add the close button if set
        var $closeBtn = $( '<button/>' )
            .attr( {
                type: 'button',
                'data-dismiss': 'modal',
                'aria-label': 'Close'
            } )
            .addClass( 'close' );

        var $cross = $( '<span/>' )
            .attr( 'aria-hidden', 'true' )
            .html( '&times;' );

        if ( options.closeButton === true ) {
            $div.find( '.modal-header' ).prepend( $closeBtn.append( $cross ) );
        }

        // add the alert if category ist not default
        var set_alertMessage = function (){
            var alert = '';
            switch ( options.category ) {
                case 'info':
                    alert = $.parseHTML( '<li><i class="dv dv-li dv-infocircle dv-lg"></i>' + options.alert + '</li>' );
                    break;
                case 'success':
                    alert = $.parseHTML( '<li><i class="dv dv-li dv-success dv-lg"></i>' + options.alert + '</li>' );
                    break;
                case 'warning':
                    alert = $.parseHTML( '<li><i class="dv dv-li dv-warning dv-lg"></i>' + options.alert + '</li>' );
                    break;
                case 'danger':
                    alert = $.parseHTML( '<li><i class="dv dv-li dv-bolt dv-lg"></i>' + options.alert + '</li>' );
                    break;
            }
            return alert;
        };

        var $message = $( '<div/>' )
            .attr( 'id', options.bodyID + '-alert-' + options.category )
            .addClass( 'alert alert-' + options.category );

        var $messageList = $( '<ul/>' )
            .addClass( 'dv-ul' )
            .html( set_alertMessage );

        var $alertMessage = $message.prepend( $messageList );

        // append the alert message if category is not default
        if ( options.category != 'default' ) {
            $div.find( '.modal-body' ).prepend( $alertMessage );
        }

        // remove the bottom margin from alert if the body is empty
        if ( options.body === '' ) {
            $( '#' + options.bodyID + '-alert-' + options.category ).css( 'margin-bottom', '0' );
        }

        // add buttons to the dialog, if any
        if ( !$.isEmptyObject( options.buttons ) ) {
            $div.find( '.modal-body' ).after( '<div class="modal-footer"></div>' );
            var button_class = 'btn btn-' + options.category; // only the first button represents the category
            $.each( options.buttons, function ( key, func ){
                var button = $( '<button class="' + button_class + '" id="button-' + _setUniqueId() + '" title="' + key +'">' + key + '</button>' );
                $div.find( '.modal-footer' ).append( button );
                button.on( 'click.modal-footer', function ( evt ){
                    var closeDialog = true; // any button closes the dialog
                    // TimeOut for co-operative multi-tasking
                    setTimeout( function (){
                        if ( func && func( evt ) === false ) {
                            closeDialog = false;
                        }
                        if ( closeDialog ) {
                            $div.modal( 'hide' );
                        }
                    }, 0 );
                } );// button click
                button_class = 'btn btn-default';
            } );//each
        }//if

        // event to remove the content on close
        $div.on( 'hidden.bs.modal', function (){
            $div.removeData();
            $div.remove();
        } );

        // call the onShow function if there is one
        if ( options.onShow ) {
            options.onShow( $div );
        }//if

        if ( options.draggable === true ) {

            var $modalWrapper = $( '#' + options.id ),
                $modalDlg = $modalWrapper.find( '.modal-dialog' ),
                $handle = $modalDlg.find( '.modal-header' );

            $handle.css( 'cursor', 'move' );

            $modalDlg.draggabilly( {
                handle: '.modal-header'
            } );

            $modalDlg.on('dragEnd', function(e) {
                $(this).css('transform', 'translate(0,0)');
            });
        }

        // Prevent backdrop from getting focus and
        // remove on click, when modal.backdrop option
        // has been set true
        var $backdrop = $div.siblings( '.modal-backdrop' );

        $backdrop.attr( 'tabindex', -1 );

        $backdrop.on( 'click', function ( e ){
            e.preventDefault();

            if ( options.modal.backdrop === true ) {
                $div.modal( 'hide' );
            }
        } );

        return $div;

    }; //modalizer

    $.modalizer.options = {
        // the id of the modal
        id: 'dv-modal',

        // the id of the modal-body (the dialog content)
        bodyID: 'dv-modal-body',

        // the element to append the dialog <div> code to.  Normally, this should be left as the 'body' element.
        appendToSelector: 'body',

        // the title of the dialog
        title: '', //window.document.title || 'Dialog',

        // CSS class(es) to add to the <div class="modal"> main dialog element.  This default makes the dialog fade in.
        //dlgClass: '',

        // What kind of category (success, info, warning, or danger)
        category: 'default',

        // If category is defined, add the message text.
        alert: '',

        // CSS class(es) to specify the dialog size ('modal-lg', 'modal-sm', '').  The default creates a large dialog.  See the Bootstrap docs for more info.
        size: 'modal-lg',

        // whether to have an 'X' button at top right to close the dialog
        closeButton: true,

        body: '',

        // set titles->functions to add buttons to the bottom of the dialog
        // return false to prevent the dialogue from hiding
        buttons: {},//buttons

        // options sent into $().modal (see dux docs for .modal and its options)
        modal: {},//modal

        // makes the modal draggable
        draggable: false,

        // if set, this function will be called with a reference to the dialog once it has been
        // successfully shown.  You can also listen for modal events, but be aware that show.bs.modal
        // triggers *before* the content is added to .modal-body.
        onShow: null
    };

    // Select modals with '.draggable'
    // to make them draggable via css
    $( function (){
        $( '.modal.draggable' ).each( function (){

            var $modalDlg = $( this ).find( '.modal-dialog' );
            var $handle = $( this ).find( '.modal-header' );

            // make modal draggable on show
            $( this ).on( 'show.bs.modal', function (){

                $handle.css( 'cursor', 'move' );

                $modalDlg.draggabilly( {
                    handle: '.modal-header'
                } );
            } );

            // make modal draggable on appearance
            $modalDlg.on( 'pointerDown', $handle, function (){

                var modalY = $modalDlg.offset().top;
                var modalX = $modalDlg.offset().left;
                var $modalParent = $( this ).parents( '.modal:first' );

                // resize modal wrapper
                $modalParent.css( {
                    height: '100%',
                    width: '100%'
                } );

                // set modal to offset as before
                $( this ).offset( {
                    top: modalY,
                    left: modalX
                } );
            } );

            // clean changes after hiding modal
            $( this ).on( 'hidden.bs.modal', function (){
                $( this ).removeAttr( 'style' );
                $modalDlg.removeAttr( 'style' );
            } );
        } );
    } );

})( jQuery, window, document );